//GLOBAl LIBRARIES
import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll"; // Import de l'extension
import "./libs/splide.js";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "./libs/fancybox.js";

import "./custom/testimonials.js";
import "./custom/equipe.js";
import "./custom/timeline.js";
// import vhb from "./libs/vhb.js";
// import isotope from './libs/isotope.js';
// ScrollReveal imported in annimate.js
